// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/workspace/src/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/billing.tsx": { enumerable: true, get() { return require("/workspace/src/app/(tabs)/billing.tsx"); } },
  "./(tabs)/care.tsx": { enumerable: true, get() { return require("/workspace/src/app/(tabs)/care.tsx"); } },
  "./(tabs)/chat.tsx": { enumerable: true, get() { return require("/workspace/src/app/(tabs)/chat.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/workspace/src/app/(tabs)/index.tsx"); } },
  "./(tabs)/profile.tsx": { enumerable: true, get() { return require("/workspace/src/app/(tabs)/profile.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/workspace/src/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/workspace/src/app/_layout.tsx"); } },
  "./forms/[id].tsx": { enumerable: true, get() { return require("/workspace/src/app/forms/[id].tsx"); } },
  "./forms/completed/[id].tsx": { enumerable: true, get() { return require("/workspace/src/app/forms/completed/[id].tsx"); } },
  "./forms/index.tsx": { enumerable: true, get() { return require("/workspace/src/app/forms/index.tsx"); } },
  "./inactive-membership.tsx": { enumerable: true, get() { return require("/workspace/src/app/inactive-membership.tsx"); } },
  "./join.tsx": { enumerable: true, get() { return require("/workspace/src/app/join.tsx"); } },
  "./login.tsx": { enumerable: true, get() { return require("/workspace/src/app/login.tsx"); } },
  "./records/[id].tsx": { enumerable: true, get() { return require("/workspace/src/app/records/[id].tsx"); } },
  "./schedule.tsx": { enumerable: true, get() { return require("/workspace/src/app/schedule.tsx"); } },
  "./score.tsx": { enumerable: true, get() { return require("/workspace/src/app/score.tsx"); } },
  "./support.tsx": { enumerable: true, get() { return require("/workspace/src/app/support.tsx"); } },
  "./verify-login.tsx": { enumerable: true, get() { return require("/workspace/src/app/verify-login.tsx"); } },
  "./visits/[id].tsx": { enumerable: true, get() { return require("/workspace/src/app/visits/[id].tsx"); } },
  "./whitening.tsx": { enumerable: true, get() { return require("/workspace/src/app/whitening.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;